var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showHistoryReporting)?_c('weekly-banner-count-chart'):_vm._e(),(_vm.showCurrentReporting)?_c('banner-status-chart'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }